import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const LikeChatNutritionFeedback = lazyWithPreload(
  () => import('./LikeChatNutritionFeedback'),
)
